import { render, staticRenderFns } from "./SourceCompareStep.vue?vue&type=template&id=f54bdc16"
import script from "./SourceCompareStep.ts?vue&type=script&lang=ts&external"
export * from "./SourceCompareStep.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f54bdc16')) {
      api.createRecord('f54bdc16', component.options)
    } else {
      api.reload('f54bdc16', component.options)
    }
    module.hot.accept("./SourceCompareStep.vue?vue&type=template&id=f54bdc16", function () {
      api.rerender('f54bdc16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Steps/SourceCompareStep.vue"
export default component.exports